<template>
  <div class="flex flex-col w-full overflow-hidden">
    <div class="w-full h-full flex-grow overflow-y-auto" @scroll="handleScroll">
      <div class="w-full max-w-content mx-auto">
        <div class="h-18" ref="spacer"></div>
        <h2 class="font-sans text-2xl uppercase text-center mb-8" ref="pageTitle">{{ pageTitle }}</h2>
        <div class="px-4 md:px-0">
          <main-navigation :data="security" />
        </div>
        <!-- <div class="mt-12 mb-12 px-4 md:px-0">
          <h4 class="text-xl uppercase font-sans mb-2 text-center">Gestión de pases</h4>
          <main-navigation :data="passManagement" />
        </div> -->
      </div>
    </div>
    <footer class="footer bg-white shadow flex-shrink-0 px-4 py-2 hidden">
      <div class="w-full max-w-content mx-auto flex items-center justify-between">
        <p>Check</p>
        <div>
          <base-button mode="primary" text="Action" />
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { handleScrollMixin } from '@/mixins/appMixin'
import MainNavigation from '@/components/MainNavigation.vue'
import status from '@/config/status'

export default {
  name: 'UserOptions',
  mixins: [handleScrollMixin],
  components: {
    MainNavigation
  },
  data: function () {
    return {
      passManagement: [
        {
          title: 'Pase cursillos',
          subtitle: 'Gestión de pases de acceso para acompañantes a cursillos.',
          icon: 'UserPass.svg',
          to: 'courses-pass'
        },
        {
          title: 'Pase Deportistas',
          subtitle: 'Gestión de pases de acceso para acompañantes de deportistas.',
          icon: 'UserPass.svg',
          to: 'sports-pass'
        },
        {
          title: 'Pase Auxiliar',
          subtitle: 'Gestión de pases de acceso para acompañantes por otros motivos.',
          icon: 'UserPass.svg',
          to: 'auxiliar-pass'
        }
      ]
    }
  },
  computed: {
    pageTitle: function () {
      return this.$route?.meta?.title
    },
    isBiometricError: function () {
      return this.$store.getters['auth/biometricStatus'] === status.ERROR
    },
    security: function () {
      return [
        {
          title: 'Acceso biométrico',
          subtitle: 'Configure el alta o la revocación del consentimiento del reconocimiento facial.',
          icon: 'facePhoto.svg',
          to: 'biometric-config',
          error: this.isBiometricError,
          textError: '<strong>Error en el procesado de la fotografía.</strong> Realice nuevamente el proceso.'
        }
        // {
        //   title: 'Carné social',
        //   subtitle: 'Solicitud de duplicado.',
        //   icon: 'UserPass.svg',
        //   to: 'membership-card-renewal'
        // }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-wrapper {
  li {
    &:first-child {
      @apply rounded-t-xl;
    }
    &:last-child {
      @apply rounded-b-xl;
    }
  }
}
</style>
